import { IPartnerPlanData } from '../../../types';

export const parnterPlanTransformer = (planDetails: IPartnerPlanData[]) => {
  return planDetails.map((input) => {
    const { coupon, ...rest } = input;

    return {
      externalId: rest.planDetails.planId,
      ...rest,
      autoApplicableCoupon: coupon,
    };
  });
};
